import { render, staticRenderFns } from "./UserArchive.vue?vue&type=template&id=3bae74dc&"
import script from "./UserArchive.vue?vue&type=script&lang=js&"
export * from "./UserArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports